/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

/**
 *
 */
export const HHT1_EP2_ANSWERS = [
    'Tony is playing with toy cars on the floor.',
    'Suddenly, Bethany calls to Tony for help.',
    'She needs help with the curtains.',
    'Tony doesn’t feel like helping.',
    'Instead, he wraps himself in the curtains.',
    'Then, the curtains fall!',
    '“Tony! What have you done?” says Bethany.',
    'Later, Howard calls to Tony for help. He needs help with the sink.',
    'He needs help with the sink.',
    'Tony doesn’t feel like helping.',
    'Instead, he starts playing with the wrench on the sink.',
    'Then, he breaks the faucet, and water starts streaming out of the pipe!',
    '“Tony! What have you done?” says Howard.',
    'Howard is worried about Tony.',
    'Bethany isn’t worried.',
    'She defends Tony.',
    'Then, Tony knocks over a plant pot in the bathroom, but Bethany defends him again.',
    'Meanwhile, Tony is about to draw on Bethany’s favorite purse.',
    'Suddenly, Bethany calls to Tony for help. She needs help with the curtains.'
];

// export const HHT1_EP2_ANSWER_SOUNDS = [
//     '/1_EP02_SB_TL_01.mp3',
//     '/1_EP02_SB_TL_02.mp3',
//     '/1_EP02_SB_TL_03.mp3',
//     '/1_EP02_SB_TL_04.mp3',
//     '/1_EP02_SB_TL_05.mp3',
//     '/1_EP02_SB_TL_06.mp3',
//     '/1_EP02_SB_TL_07.mp3',
//     '/1_EP02_SB_TL_08.mp3',
//     '/1_EP02_SB_TL_09.mp3',
//     '/1_EP02_SB_TL_10.mp3',
//     '/1_EP02_SB_TL_11.mp3',
//     '/1_EP02_SB_TL_12.mp3',
//     '/1_EP02_SB_TL_13.mp3',
//     '/1_EP02_SB_TL_14.mp3',
//     '/1_EP02_SB_TL_15.mp3',
//     '/1_EP02_SB_TL_16.mp3',
//     '/1_EP02_SB_TL_17.mp3',
//     '/1_EP02_SB_TL_18.mp3',
//     '/1_EP02_SB_TL_19.mp3',
//     '/1_EP02_SB_TL_20.mp3',
//     '/1_EP02_SB_TL_21.mp3',
//     '/1_EP02_SB_TL_22.mp3',
//     '/1_EP02_SB_TL_23.mp3',
// ];

export const HHT1_EP2_ANSWER_SOUNDS = [
    '/a2ee644dec8f485288f54d97d5b19ecd.mp3',
    '/5a9021d5384eff00b63c55bfc5169bbd.mp3',
    '/8170b09414416106546ed146c845b7bb.mp3',
    '/4a23c99226a2b6382d4873ccaf0a71c1.mp3',
    '/f8467fa543278563da575fda6730faab.mp3',
    '/c7730d6064ed93415c5ae6598ae143b9.mp3',
    '/95209819fd71c00f3b5c45b2063f275c.mp3',
    '/cbeb1b97a438d7916a5e13b797d2c8e8.mp3',
    '/6ad28cf75e41430fab534560f1485584.mp3',
    '/b8d3edbe544eb9467eec7e90fb3cd891.mp3',
    '/baf2d4ff32518aca696b798f43af2aec.mp3',
    '/53a4f87b76a3e5848830aed42be220d7.mp3',
    '/53bd82a5294d8996f4fd2477f4ace002.mp3',
    '/605c538ee2b1c6878c2c6a93ef4cae57.mp3',
    '/2f9685565cbc50340ab650714a763807.mp3',
    '/d71075b4bb4f553e86a0dbc4bc4667ac.mp3',
    '/58aec25fb610ac9acc7d783409eced48.mp3',
    '/692b88f03cb05b60337eff2e502f62eb.mp3',
    '/128c7f7cfd086d37e12c2496e6e1e595.mp3',
    '/e6b3044848a6054173bb71dc4edc1a3f.mp3',
    '/1768aa7e10967baa8a5af51fd371d107.mp3',
    '/ae63978ee06d5d27b1da480e8b5dd7d9.mp3',
    '/f10d10ddbe3e140506c4b2f8dfea25c4.mp3',
];

export const HHT1_EP2_QUIZ_ITEMS = [{
    'A': HHT1_EP2_ANSWERS[18],
    'B': HHT1_EP2_ANSWERS[14],
    'SoundIndexA': 22,
    'SoundIndexB': 14,
    'answer': HHT1_EP2_ANSWERS[18],
    'sound': [18],
    'exception': false,
},
    {
        'A': HHT1_EP2_ANSWERS[13],
        'B': HHT1_EP2_ANSWERS[5],
        'SoundIndexA': 13,
        'SoundIndexB': 5,
        'answer': HHT1_EP2_ANSWERS[5],
        'sound': [6],
        'exception': false,
    },
    {
        'A': HHT1_EP2_ANSWERS[16],
        'B': HHT1_EP2_ANSWERS[7],
        'SoundIndexA': 16,
        'SoundIndexB': 21,
        'answer': HHT1_EP2_ANSWERS[7],
        'sound': [19, 11],
        'exception': false,
    },
    {
        'A': HHT1_EP2_ANSWERS[12],
        'B': HHT1_EP2_ANSWERS[9],
        'SoundIndexA': 12,
        'SoundIndexB': 9,
        'answer': HHT1_EP2_ANSWERS[12],
        'sound': [13, 20],
        'exception': true,
    },
    {
        'A': HHT1_EP2_ANSWERS[16],
        'B': HHT1_EP2_ANSWERS[3],
        'SoundIndexA': 16,
        'SoundIndexB': 3,
        'answer': HHT1_EP2_ANSWERS[16],
        'sound': [17],
        'exception': false,
    },

]
